<template>
    <div>
        <el-dialog
                title="提示"
                id="nbHelpDialog"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                width="1180px">
            <div>
                <el-carousel ref="helpCarousel" trigger="click" arrow="never" indicator-position="none" :autoplay="false">
                    <el-carousel-item v-for="(item,index) in backgroundImg" :key="item.src">
                        <div style="position: relative">
                            <img :src="item.src" width="100%" alt="">
                            <a v-if="index > 0" @click="carouselPrev(item)" class="helpBtn helpBtn-left" href="javascript:(0)"></a>
                            <a v-if="index < 4" @click="carouselNext(item)" class="helpBtn helpBtn-right" href="javascript:(0)"></a>
                            <a @click="knowBtn" class="knowBtn" v-if="index==4" href="javascript:(0)"></a>
                            <a @click="knowBtn" class="closeBtn" href="javascript:(0)">
                                <img src="/static/images/icon_close.png" alt="">
                            </a>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                dialogVisible:false,
                backgroundImg:[
                    {src:'/static/images/help_1.png'},
                    {src:'/static/images/help_2.png'},
                    {src:'/static/images/help_3.png'},
                    {src:'/static/images/help_4.png'},
                    {src:'/static/images/help_5.png'},
                ]
            }
        },
        methods:{
            carouselPrev($num){
                this.$refs.helpCarousel.prev();
            },
            carouselNext($num){
                this.$refs.helpCarousel.next();
            },
            dialogHelpShow(){
                this.dialogVisible=true;
            },
            knowBtn(){
                this.dialogVisible = false
                this.$refs.helpCarousel.setActiveItem(0);
            }
        }
    }
</script>
<style>
    #nbHelpDialog .el-dialog__header{
        display:none
    }
    #nbHelpDialog .el-dialog__body{
        padding:0;
        height:737.5px;
    }
    #nbHelpDialog .el-carousel__container{
        height:737.5px;
    }
    .helpBtn{
        width: 50px;
        height: 50px;
        position: absolute;
        top:calc(50% - 72px);
    }
    .helpBtn-left{
        left:25px;
        background: url("/static/images/left_pressed.png") no-repeat;
    }
    .helpBtn-right{
        right:25px;
        background: url("/static/images/right_pressed.png") no-repeat;
    }
    .helpBtn-right:hover{
        background: url("/static/images/right_default.png") no-repeat;
    }
    .helpBtn-left:hover{
        background: url("/static/images/left_default.png") no-repeat;
    }
    .knowBtn{
        position: absolute;
        bottom: 30px;
        right: 50px;
        width: 166px;
        height: 64px;
        background: url("/static/images/button_pressed.png") no-repeat;
    }
    .knowBtn:hover{
        background: url("/static/images/button_default.png") no-repeat
    }
    .closeBtn{
        position: absolute;
        right: 0;
        top: 0;
    }
</style>


// WEBPACK FOOTER //
// src/assets/js/pages/common/Help.vue